/**
 * Generated by orval v8.2.0 🍺
 * Do not edit manually.
 * Fragment Payments API
 * REST API for Fragment payment operations
 * OpenAPI spec version: 1.0.0
 */

/**
 * Type of payment flow.
 */
export type CreatePaymentFlowRequestType =
  (typeof CreatePaymentFlowRequestType)[keyof typeof CreatePaymentFlowRequestType];

export const CreatePaymentFlowRequestType = {
  single_invoice_settlement: 'single_invoice_settlement',
} as const;
